import Marionette from 'backbone.marionette';
import JoinosCodeListView from '../views/list';
import JoinosCodeCollection from '../collections/codes';

module.exports = function (options) {
  var regions = new Marionette.RegionManager({
    regions: {
      view: '#layout-hook'
    }
  });

  var collection = new JoinosCodeCollection();
  collection.reset(collection.parse(options['initialData']));

  var layout = new JoinosCodeListView({
    collection
  });
  regions.get('view').show(layout);
};



// WEBPACK FOOTER //
// ./joinos_codes/initializers/list.js